import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { isProd } from 'helpers/helper';
import { UserContext } from 'contexts/user/UserContext';
import { resolveAnonymousHomeDestination } from './Auth/authLoopGuards';

const Home = (): React.ReactElement => {
  const { isAuthenticated } = useContext(UserContext);
  const history = useHistory();
  const landingPage = import.meta.env.VITE_HOME_URL || (isProd ? '/about' : '/login');

  useEffect(() => {
    if (isAuthenticated) {
      history.replace('/profile');
      return;
    }

    // A VITE_HOME_URL of "/" used to reload Home forever.
    window.location.replace(resolveAnonymousHomeDestination(landingPage, window.location.href));
  }, [history, isAuthenticated, landingPage]);

  return <div className="loading" />;
};

export default Home;
